<!-- 头部 -->
<template>
	<div class="topTitle">
		<div class="bgColor">
			<img src="../assets/img/logo.png" alt="禾溪数字">
			<div class="lists">
				<div v-for="(item,index) in lists" :key="index" class="singleList" 
				:class="{ activeList: $store.state.iscur == index }" @click="setCur(index)">

					<p>{{ item.nameT }}</p>
					<p style="margin-top:13px;font-weight: bold;" v-if="item.type=='overseas'">{{ item.nameB }}</p>
					<p :class="{'toEnglish':isActive}" v-else>{{ item.nameB }}</p>
				</div>
				
			</div>
		</div>
		<div class="changeLanguage">
			<!-- <p>{{ $t('message') 测试用的 }}</p>-->
			<span @click="setLanguage('zh')">中文 </span> |
			<span @click="setLanguage('en')"> English</span>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				isActive:false,
			}
		},
		computed: {
			lists() {
				return this.$t('lists'); // 获取翻译的 lists
			}
		},
		mounted() {
			this.init()
		},
		methods: {
			setLanguage(lang){
				console.log(lang)
				this.$i18n.locale = lang; 
				this.$store.state.currentLanguage= lang
				if(lang == 'zh'){
					this.isActive = false
				}else{
					this.isActive = true
				}
			},
			setCur(index) {//本地会话存储菜单
				this.$store.state.iscur = index
				if(index != null ){//判断iscur不为空时再进行跳转
					this.$router.push({ path: this.lists[index].path})//跳转地址
				}
				document.documentElement.scrollTop = 0;//切换时滚动条在最上面
  				document.body.scrollTop = 0;//切换时滚动条在最上面
				sessionStorage.setItem("changeId", index)//设置session
				sessionStorage.setItem("changeLeftListId", 0)//左侧菜单的session清零
			},
			init(){
				var paths = this.$route.path//获取当前path，并且在mounted加载时就获取到path值
				var changId = sessionStorage.getItem('changeId')
				if(changId !=undefined){
					this.$store.state.iscur = changId
				}
				this.setCur(this.$store.state.iscur)
				if(paths == '/home'){
					this.$store.state.iscur = 0
				}else if (paths == '/overseas'){
					this.$store.state.iscur = 1
				}else if(paths == '/product'){
					this.$store.state.iscur = 2
				}else if(paths == '/solution'){
					this.$store.state.iscur = 3
				}else if(paths == '/case'){
					this.$store.state.iscur = 4
				}else if(paths == '/aboutUs'){
					this.$store.state.iscur = 5
				}
			},
			
		}
	}
</script>

<style scoped lang="scss">
	.topTitle {
		width: 100vw;
		position: fixed;
		top:0px;
		z-index:8888;
		background-color:#fff;
		.bgColor {
			width: 1200px;
			height:75px;
			margin: 0 auto;
			position: relative;
			display: flex;
			img{
				width: 110px;
				height: 50px;
				margin-top:15px;
			}
		}
		.changeLanguage{
			position:absolute;
			right:50px;
			top:20px;
			span{
				cursor: pointer;
				transition:all 0.5s linear
			}
			span:hover{
				color:#409eff;
			}
		}
	}
	.toEnglish{
		margin-top:10px;
	}
	.lists{
		display: flex;
		margin-left:100px;
		.singleList{
			padding: 12px 30px 0px;
			p{
				text-align: center;
				transition: all 0.4s;
			}
			transition: all 0.5s;
		}
		.singleList:hover{
			cursor: pointer;
			background-color: #409eff;
			p{
				color:#fff;
			}
		}
		.activeList{
			background-color: #409eff;
			color:#fff;
		}
	}
</style>
